module.exports = __webpack_public_path__ + "static/media/food@3x.ab38aab0.png";